import { HeadersWithoutIterator } from './types/HeadersWithoutIterator';
import { setHeaders } from './utils/setHeaders';
import { getExplicitLogonHeaders } from './getExplicitLogonHeaders';

export default function setExplicitLogonHeaders(smtp: string, headers: HeadersWithoutIterator) {
    if (headers && smtp) {
        setHeaders(headers, getExplicitLogonHeaders(smtp));
    }
}
